import axios from 'axios'
import { z } from 'zod'
import { axiosClient } from '../../clients/axios-client'

export interface FileContentResponse {
  html: string
}

const FileHtmlResponseSchema = z.string()

async function getFileHtml(url: string): Promise<string> {
  try {
    const { data } = await axiosClient.get<string>(url, { responseType: 'text' })
    // Validate response is a string
    return FileHtmlResponseSchema.parse(data)
  } catch (error) {
    if (
      axios.isAxiosError(error) &&
      (error.response?.status === 404 || error.response?.status === 400)
    ) {
      // Treat missing file/section as "no preview available" rather than error
      return ''
    }
    throw error
  }
}

export async function getFileContent(fileId: string): Promise<FileContentResponse> {
  const trimmedFileId = fileId.trim()
  if (!trimmedFileId) {
    throw new Error('File ID is required')
  }

  const encodedFileId = encodeURIComponent(trimmedFileId)
  const html = await getFileHtml(`/filepool/files/${encodedFileId}/html`)

  return { html }
}
